import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useNote } from "../hooks/useNote";
import NoteDisplay from "./NoteDisplay";

const NoteDetailByURL: React.FC = () => {
  const { URLfriendlyname } = useParams<{ URLfriendlyname: string }>();
  const navigate = useNavigate();

  const { note, loading, error } = useNote(URLfriendlyname || "", true);

  const handleBack = () => {
    navigate("/notes");
  };

  return (
    <NoteDisplay
      note={note}
      loading={loading}
      error={error}
      identifier={URLfriendlyname || ""}
      isURLFriendly={true}
      onBack={handleBack}
    />
  );
};

export default NoteDetailByURL;
